import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import { getAdminSupplementInquiryStatuses } from '@api/adminSupplements';
import { IAdminSupplementInquiryStatus } from '@interfaces/adminSupplements';

export const handleGetAdminSupplementInquiryStatuses = createAsyncThunk<
  AxiosResponse<IAdminSupplementInquiryStatus[]>,
  void
>('getAdminSupplementInquiryStatuses', getAdminSupplementInquiryStatuses);
